define.alias("ember-math-helpers/helpers/log-e", "calendar/helpers/log-e");